import { Create, SimpleForm, TextInput, maxLength, minLength, required } from 'react-admin';

export const NotificationCreate = () => {
  const validateTitle = [required(), minLength(3), maxLength(15)];
  const validateNotificationTitle = [required(), minLength(3), maxLength(30)];
  const validateNotificationText = [required(), minLength(3), maxLength(200)];

  return (
    <Create title="Создание уведомления">
      <SimpleForm redirect="list">
        <TextInput label="Название" source="title" validate={validateTitle} />
        <TextInput label="Заголовок уведомления" source="notificationTitle" validate={validateNotificationTitle} />
        <TextInput label="Текст уведомления" source="notificationText" validate={validateNotificationText} multiline />
      </SimpleForm>
    </Create>
  );
};

export default NotificationCreate;
